module.exports = __webpack_public_path__ + "static/quiz_stage_3_bg-187cc9ea7e0cb8cfb29a483865ba8b35.svg";